import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { PartTypePerPartRequest } from "@/main/models/request/partTypePerPartRequest";
import { PartTypePerPartResponse } from "@/main/models/response/partTypePerPartResponse";

export abstract class IPartTypePerPartApi {
	abstract savePartTypePerPart(
		request: PartTypePerPartRequest,
	): Promise<AxiosResponse<Result<PartTypePerPartResponse>>>;

	abstract deletePartTypePerPart(request: string[]): Promise<AxiosResponse<Result<any>, any>>;
}
